import type {
  CashAndBankRepository,
  GetWeeklyCashFlowParams,
  GetRecentBankTransactionsParams,
  GetReconciliationStatusParams,
} from "../../domain/repositories/CashAndBankRepository";
import type { AllBankAccountsEntity } from "../../domain/entities/AllBankAccountsEntity";
import type { WeeklyCashFlowEntity } from "../../domain/entities/WeeklyCashFlowEntity";
import type { RecentBankTransactionsEntity } from "../../domain/entities/RecentBankTransactionsEntity";
import type { ReconciliationStatusEntity } from "../../domain/entities/ReconciliationStatusEntity";
import {
  getAllAccounts,
  getWeeklyCashFlow,
  getRecentBankTransactions,
  getReconciliationStatus,
} from "../api/cashAndBankApi";
import { allBankAccountsDtoToEntity } from "../mappers/allBankAccountsMapper";
import { weeklyCashFlowDtoToEntity } from "../mappers/weeklyCashFlowMapper";
import { recentBankTransactionsDtoToEntity } from "../mappers/recentBankTransactionsMapper";
import { reconciliationStatusDtoToEntity } from "../mappers/reconciliationStatusMapper";

export class CashAndBankRepositoryImpl implements CashAndBankRepository {
  async getAllAccounts(): Promise<AllBankAccountsEntity> {
    const dto = await getAllAccounts();
    return allBankAccountsDtoToEntity(dto);
  }

  async getWeeklyCashFlow(
    params?: GetWeeklyCashFlowParams,
  ): Promise<WeeklyCashFlowEntity> {
    const dto = await getWeeklyCashFlow(params);
    return weeklyCashFlowDtoToEntity(dto);
  }

  async getRecentBankTransactions(
    params: GetRecentBankTransactionsParams
  ): Promise<RecentBankTransactionsEntity> {
    const dto = await getRecentBankTransactions(params);
    return recentBankTransactionsDtoToEntity(dto);
  }

  async getReconciliationStatus(
    params: GetReconciliationStatusParams
  ): Promise<ReconciliationStatusEntity> {
    const dto = await getReconciliationStatus(params);
    return reconciliationStatusDtoToEntity(dto);
  }
}
